import { LoadingStatuses } from '@/common/constants';
import { AppButton } from '@/ui/buttons';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledDialog = styled(Dialog)`
  &.p-dialog {
    border-radius: var(--medium-border-radius);

    .p-dialog-header {
      padding: var(--semi-big-padding) var(--semi-big-padding) 0;
    }

    .p-dialog-title {
      font-size: var(--modal-heading-font-size);
      font-weight: 700;
      line-height: 1.4;
    }

    .p-dialog-content {
      padding: var(--semi-xsmall-padding) var(--semi-big-padding) 0;
      font-size: var(--small-font-size);
      line-height: 1.5;
    }

    .p-dialog-footer {
      padding: 31px var(--semi-big-padding) var(--semi-big-padding);
      display: flex;
      gap: var(--semi-xsmall-padding);
    }
  }
`;

type RestoreUsersModalProps = {
  visible: boolean;
  count: number;
  restoring?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export const RestoreUsersModal: React.FC<RestoreUsersModalProps> = ({
  visible,
  count,
  restoring = false,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <StyledDialog
      visible={visible}
      onHide={onClose}
      header={t('dialog.restore.users.header', { count })}
      closable={false}
      draggable={false}
      footer={
        <>
          <AppButton
            label={t('button.restoreUser', { count })}
            state={restoring ? LoadingStatuses.LOADING : LoadingStatuses.IDLE}
            isDisabled={restoring}
            onClick={onConfirm}
          />
          <AppButton
            label={t('button.cancel')}
            severity="secondary"
            type="outlined"
            isDisabled={restoring}
            onClick={onClose}
          />
        </>
      }
    >
      <p>{t('dialog.restore.users.message', { count })}</p>
    </StyledDialog>
  );
};
